module.exports = __webpack_public_path__ + "img/bity.6697da2a.svg";